import {
  MY_APPOINMENT,
  APPOINTMENT_UPDATE,
  APPOINTMENT_CREATE,
  SET_APPOINTMENT_DATA,
  MY_APPOINMENT_CLEAR,
} from "../constant/index";
import { sortAppointmentVehiclesForList } from "../utils/appointmentBooking";

const INITIAL_STATE = {
  loading: false,
  data: [],
  UpdateData: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${MY_APPOINMENT}_REQUEST`:
      return { ...state, loading: true };
    case `${MY_APPOINMENT}_SUCCESS`:
      return {
        ...state,
        data: sortAppointmentVehiclesForList(action.payload),
        loading: false,
      };
    case `${MY_APPOINMENT}_FAIL`:
    case `${MY_APPOINMENT}_ERROR`:
      return { ...state, loading: false };

    case `${APPOINTMENT_CREATE}_FAIL`:
      return { ...state, loading: false };
    case `${APPOINTMENT_CREATE}_ERROR`:
      return { ...state, loading: false };
    //
    case `${APPOINTMENT_CREATE}_REQUEST`:
      return { ...state };
    // case `${APPOINTMENT_CREATE}_SUCCESS`:
    //   // console.log("APPOINxxxxTMENT_CREATE",action.payload)
    //   return { ...state,
    //     UpdateData:action.payload,
    //   };
    case `${APPOINTMENT_CREATE}_UPDATE`:
    case `${APPOINTMENT_UPDATE}_UPDATE`: {
      const payloadData = action.payload.bodyData?.data || {};
      let updateIndex = payloadData.updateIndex;
      const evaluationId = payloadData.evaluation;

      if (evaluationId != null) {
        const matchIndex = state.data.findIndex(
          (item) => String(item?.id) === String(evaluationId)
        );
        if (matchIndex >= 0) {
          updateIndex = matchIndex;
        }
      }

      const obj = state.data[updateIndex];
      const appointmentPayload = action.payload.data || {};
      const updateObj = {
        ...obj,
        appointment: [
          {
            ...(Array.isArray(obj?.appointment) ? obj.appointment[0] : obj?.appointment),
            ...appointmentPayload,
          },
        ],
      };
      const stateData = [...state.data];
      stateData[updateIndex] = updateObj;
      return {
        ...state,
        data: sortAppointmentVehiclesForList(stateData),
      };
    }



      case SET_APPOINTMENT_DATA:
        return {
          ...state,
          data: sortAppointmentVehiclesForList(action.payload.data),
        };
      case MY_APPOINMENT_CLEAR:
        // console.log("MY_APPOINMENT_CLEAR")
        return { ...state, data: [],};





    // case `${MY_APPOINMENT}_FAIL`:
    //   return { ...state, loading: false };
    // case `${MY_APPOINMENT}_ERROR`:
    //   return { ...state, loading: false };
    // //
    //   case `${APPOINTMENT_UPDATE}_REQUEST`:
    //   return { ...state, };
    // case `${APPOINTMENT_UPDATE}_SUCCESS`:
    //   // console.log("APPOINTMENT_UPDATE",action.payload)
    //   return { ...state,
    //     UpdateData:action.payload,
    //   };
  }

  return state;
};
